import { findIndex } from '../../../utils/base'

export default {
  myResult(state, _getters, _rootState, rootGetters) {
    const { myUid } = rootGetters
    let { _myLuckyInfo, _myRandomInfo, randomWinners } = state
    if(!myUid || !_myLuckyInfo || !_myRandomInfo) {
      return null
    }
    const rank =
      _myLuckyInfo.rank > 0
        ? _myLuckyInfo.rank
        : _myRandomInfo.rank > 0
        ? _myRandomInfo.rank
        : 0
    let randomOid = 0
    if (randomWinners && myUid > 0) {
      randomOid = findIndex(randomWinners, d => d.uid === myUid) + 1
    }

    return {
      rank,
      lucky: _myLuckyInfo.rewardFlag > 0,
      random: _myRandomInfo.rewardFlag > 0,
      randomOid
    }
  }
}
